'use client';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/context/Auth';
import { ResponseSchema } from '@/api/types';
import Axios from '@/lib/axiosConfig';

export interface CreateEducationRequest {
  name: string;
  neighborhoodID: string;
  overview: string;
  setting: string;
  enrollment: string;
  acceptanceRate: number;
  agesEnrolled: string;
  partOrFullTime: string;
  applicationDeadline: string;
  applicationFee: number;
  studentFacultyRatio: string;
  method: string;
  topSecondaries: string[];
  thumbnailImage: string;
  coverImage: string;
  categoryID: string;
  curriculum: string;
  isReligious: boolean;
  specialties: string[];
  fullTimeCost: string;
  fullTimeRegistrationCost: number;
  fullTimeSuppliesCost: number;
  partTimeCost: string;
  partTimeRegistrationCost: number;
  partTimeSuppliesCost: number;
  doesProvideScholarships: boolean;
  doesProvideGrants: boolean;
  clubs: string[];
  sports: string[];
  neighborhoodCrimeInfo:string;
  email?:string;
  phone?:string;
  workHours?:string;
  website?:string;
  campusSize: number;
  culture: string;
  coordinates: number[];
}

type CreateEducationRes = ResponseSchema<{
  id: string;
}>;

export const useCreateEducationMutation = () => {
  const { getAPIRequestTokenHeaders } = useAuth();
  const queryClient = useQueryClient();

  return useMutation<CreateEducationRes, Error, CreateEducationRequest>({
    mutationFn: (data) =>
      Axios.post('/educations', data, {
        headers: getAPIRequestTokenHeaders(),
      }).then((res) => res.data),
    onSuccess: () => {
      // Invalidate education-related queries
      queryClient.invalidateQueries({
        queryKey: ['educations'],
      });
      queryClient.invalidateQueries({
        queryKey: ['educations/my'],
      });
    },
  });
};
